import { Component } from '@angular/core';

@Component({
  selector: 'app-alert-demo-api-spec',
  imports: [],
  templateUrl: './alert-demo-api-spec.component.html',
  styleUrl: './alert-demo-api-spec.component.scss',
})
export class AlertDemoApiSpecComponent {}
